const SHOP_NAME = 'premier-lacrosse-league-shop'
export const SHOP_STOREFRONT_URL = `https://${SHOP_NAME}.myshopify.com`
export const SHOP_API_VERSION = '2025-04'
export const SHOP_STOREFRONT_TOKEN_PUBLIC =
  process.env.REACT_APP_SHOPIFY_STOREFRONT_KEY || ''
export const SHOP_GRAPHQL_URL = `${SHOP_STOREFRONT_URL}/api/${SHOP_API_VERSION}/graphql.json`

export const SHOP_COLLECTIONS: { [key: string]: string } = {
  MAIN: 'gid://shopify/Collection/288920338584',
  ARC: 'gid://shopify/Collection/80232644660',
  ATL: 'gid://shopify/Collection/132444848180',
  CAN: 'gid://shopify/Collection/235055644824',
  CHA: 'gid://shopify/Collection/132444880948',
  OUT: 'gid://shopify/Collection/293297520792',
  RED: 'gid://shopify/Collection/132444946484',
  WAT: 'gid://shopify/Collection/159624658996',
  WHP: 'gid://shopify/Collection/132444520500',
}

export type PLLNShopItem = {
  id: string // Shopify Product Id
  level: number
}
export const SHOP_PLLN_ITEMS = [
  {
    id: 'gid://shopify/Product/7586407383192',
    level: 5,
  },
]
